"use client";

import type { CSSProperties, ReactNode } from "react";
import { useReveal } from "@/lib/hooks/useReveal";

type RevealVariant = "rise" | "line-x" | "line-y";

type RevealProps = {
  children?: ReactNode;
  className?: string;
  variant?: RevealVariant;
  delay?: number;
};

const variantClass: Record<RevealVariant, string> = {
  rise: "reveal",
  "line-x": "reveal-line-x",
  "line-y": "reveal-line-y",
};

export function Reveal({
  children,
  className,
  variant = "rise",
  delay = 0,
}: RevealProps) {
  const { ref, revealed } = useReveal<HTMLDivElement>(delay);

  return (
    <div
      ref={ref}
      data-revealed={revealed ? "true" : "false"}
      style={{ "--reveal-delay": `${delay}ms` } as CSSProperties}
      className={[variantClass[variant], className].filter(Boolean).join(" ")}
    >
      {children}
    </div>
  );
}
